import { MessageText } from "../styles";

export default function CompleteMessageSection() {
  return (
    <MessageText>
      お問い合わせありがとうございます。
      <br />
      弊社コンシェルジュが査定に必要な情報をまとめるため、一度だけお電話させていただきますので、ご対応いただけますと幸いです。
      <br />
      ※不動産会社からの営業電話は一切ありません。
    </MessageText>
  );
}
